<template>
  <div class="wizard_step"
       :class="{'--completed':completed,'--current':current}">
    <font-awesome-icon v-if="current"
                       class="absolute right-8 top-1/2 transform -translate-y-1/2 text-md"
                       icon="chevron-right"/>
    <div class="number">{{ index }}</div>
    <div class="description">
      <div class="title">
        {{ title }}
        <IconRoundTick v-if="completed"/>
      </div>
      <div class="text">{{ text }}</div>
    </div>
  </div>
</template>

<script>

import IconRoundTick from "@/components/icons/IconRoundTick";

export default {
  name: "TheWizardNavItem",
  components: {IconRoundTick},
  props: {
    index: {
      type: Number,
      required: true
    },
    current: {
      type: Boolean,
      required: true
    },
    completed: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
  }
}
</script>

<style lang="scss" scoped>
.wizard_step {
  @apply bg-block rounded overflow-hidden relative shadow-primaryBlock;
  padding: 20.6px 58px 22px 20px;
  margin-right: -5px;

  .number {
    @apply absolute font-bold text-bg ;
    font-size: 190px;
    line-height: 150px;
    top: 0;
    left: -19px;
  }

  .description {
    @apply relative z-0;
  }

  .title {
    @apply text-xl font-bold text-text mb-5 flex items-center;
    svg {
      @apply ml-4 text-green;
      width: 18px;
      height: 18px;
      filter: drop-shadow(0px 2px 8px rgba(39, 174, 96, 0.3));
    }
  }

  .text {
    @apply text-sm text-text-ternary;
    line-height: 1.4;
  }


  &.--current {
    @apply text-white bg-green;

    .number {
      @apply absolute font-bold text-green-light;
      opacity: 0.3;
    }

    .title, .text {
      @apply text-white;
    }
  }

}

</style>